export const person = [
  {
    path: '/person',
    component: () => import(/* webpackChunkName: "person" */ '@/views/person/Person'),
    children: [
      {
        path: 'create',
        components: {
          body: () => import(/* webpackChunkName: "person" */ '@/views/person/components/PersonEditBody'),
          bar: () => import(/* webpackChunkName: "person" */ '@/views/person/components/PersonEditBar'),
        },
      },
      {
        path: ':id/edit',
        components: {
          body: () => import(/* webpackChunkName: "person" */ '@/views/person/components/PersonEditBody'),
          bar: () => import(/* webpackChunkName: "person" */ '@/views/person/components/PersonEditBar'),
        },
      },
      {
        path: ':id/picture',
        components: {
          body: () => import(/* webpackChunkName: "person" */ '@/views/person/components/PersonPictureBody'),
          bar: () => import(/* webpackChunkName: "person" */ '@/views/person/components/PersonPictureBar'),
        }
      },
      {
        path: ':id/participations',
        components: {
          body: () => import(/* webpackChunkName: "person" */ '@/views/person/components/PersonParticipationsBody'),
          bar: () => import(/* webpackChunkName: "person" */ '@/views/person/components/PersonParticipationsBar'),
        }
      },
      {
        path: ':id/funding',
        components: {
          body: () => import(/* webpackChunkName: "person" */ '@/views/person/components/PersonFundingBody'),
          bar: () => import(/* webpackChunkName: "person" */ '@/views/person/components/PersonFundingBar'),
        }
      },
    ]
  },
]
